import register from '../entrypoint';

import ReservationWidgetContainer from '../widgets/container/ReservationWidgetContainer';

// Styles
import '../stylesheets/widgets.scss';

register({ ReservationWidgetContainer });
